import React from "react";
import {HomeEffectLines} from "./HomeEffect";

const PercenterLine = ({ percent, text }) => {
    return (
        <div className="flex justify-center gap-[16px] items-center pl-[8px]">

            <div className="w-[10px] h-[10px] bg-[#d3aa86] rounded z-10">
            </div>

            <div className={`w-[62px] h-[62px] bg-[#d3aa86] flex items-center justify-center font-semibold text-white text-[24px] rounded-[31px] mb-[10px] `}>
                {percent}%
            </div>
            <div className="w-[219px]">
                {text}
            </div>
        </div>
    )
}

export default function HomeEffectMobile() {
    const sortedLines = [...HomeEffectLines].sort((a, b) => a.order - b.order);

    return (
        <div className="relative w-full max-w-[360px] h-auto mt-[80px] flex justify-center items-center">            

            <div className="w-full max-w-[320px] md:max-w-full flex-col">
                <div className="text-left md:text-center text-[20px] font-bold font-['Open Sans'] bg-gradient-to-r from-[#6082A0] to-[#E55961] text-transparent bg-clip-text px-4">
                    Влияние на бизнес
                </div>

               

                <div className="flex flex-col justify-center max-w-[320px] w-full gap-[70px] mt-[30px] relative">
                    
                    <hr className="absolute h-[1px] w-[576px] bg-[#d3aa86] border-[#d3aa86] rotate-[90deg] top-[320px] ml-[-275px] z-0" />

                    {sortedLines.map((line, index) => (
                        <PercenterLine key={index} {...line} />
                    ))}
                </div>
            </div>
        </div>
    );
};
